import { createContext } from 'react';

interface ISpinnerContext {
  open: () => void;
  close: () => void;
}

export const SpinnerContext = createContext<ISpinnerContext | undefined>(undefined);
